import { Button } from '@/components/tiptap-editor/tiptap-ui-primitive/button';
import { Maximize, Minimize } from 'lucide-react';
import { useEffect, type Dispatch, type SetStateAction } from 'react';
import { registerFullscreenEscape } from './fullscreen-escape-stack';

interface ZyFullscreenToggleProps {
    isFullscreen: boolean;
    setIsFullscreen: Dispatch<SetStateAction<boolean>>;
    className?: string;
}

export const ZyFullscreenToggle = ({ isFullscreen, setIsFullscreen, className }: ZyFullscreenToggleProps) => {
    useEffect(() => {
        if (!isFullscreen) {
            return;
        }
        const exit = () => setIsFullscreen(false);
        return registerFullscreenEscape(exit);
    }, [isFullscreen, setIsFullscreen]);

    return (
        <Button
            onClick={() => setIsFullscreen(prev => !prev)}
            className={`rounded p-1.5 text-gray-600 !bg-transparent transition-colors hover:bg-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 ${className}`}
            tooltip={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
            shortcutKeys={isFullscreen ? 'Escape' : ''}
            showTooltip={true}
            onMouseDown={e => e.preventDefault()}
        >
            {isFullscreen ? <Minimize className="h-4 w-4" /> : <Maximize className="h-4 w-4" />}
        </Button>
    );
};
